import { apiClient } from '@/libs/axios';
import type { ApiParamsDefault, ApiResponsePagination } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import type { User } from '../types/user.type';

export type GetListUserParams = Partial<ApiParamsDefault> & {
  status?: 'active' | 'inactive';
  verified?: 'true' | 'false';
  type?: 'user' | 'mentor';
};
export type GetListUserResponse = ApiResponsePagination<User>;

export const getListUser = async (
  params?: GetListUserParams
): Promise<GetListUserResponse> => {
  const url = 'user';

  return await apiClient.get(url, { params });
};

export const GET_LIST_USER_QUERY_KEY = 'list-user';
export function getListUserQueryOptions(params?: GetListUserParams) {
  return queryOptions({
    queryKey: [GET_LIST_USER_QUERY_KEY, params],
    queryFn: () => getListUser(params),
  });
}
